// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"1361f5c9","256":"d768068c","395":"dea3f147","455":"817cb507","659":"9de32675","899":"627845c0","977":"fd139966"}[chunkId] + ".chunk.js";
};